import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { PaymentInfoRequestCandidate } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

/**
 * Subset of the Athletes-table filter state forwarded to the candidates query
 * so the result stays reactive to the active filters combined.
 */
export interface PaymentInfoRequestFilters {
  searchTerm?: string;
  athleteStatus?: string;
  loginEnabled?: string;
  packages?: string[];
  hasPaymentMethod?: string;
  hasSignedWaiver?: string;
}

export default function usePaymentInfoRequestCandidates(
  filters: PaymentInfoRequestFilters,
  options?: { enabled?: boolean },
): UseQueryResult<PaymentInfoRequestCandidate[]> {
  const fetchCandidates = (): Promise<PaymentInfoRequestCandidate[]> => {
    const params: UrlParams = {};

    if (filters.searchTerm) {
      params.search = filters.searchTerm;
    }
    if (filters.athleteStatus) {
      params.athlete_status = filters.athleteStatus;
    }
    if (filters.loginEnabled) {
      params.profile__login_enabled = filters.loginEnabled;
    }
    if (filters.hasPaymentMethod) {
      params.has_payment_method = filters.hasPaymentMethod;
    }
    if (filters.hasSignedWaiver) {
      params.has_signed_waiver = filters.hasSignedWaiver;
    }

    return client
      .get<PaymentInfoRequestCandidate[]>(
        `athletes/payment-info-request-candidates/?${encodeUrlParams(params)}`,
      )
      .then(res => res.data);
  };

  return useQuery(['payment-info-request-candidates', filters], fetchCandidates, {
    enabled: options?.enabled ?? true,
  });
}
